import {
  DescriptionTextColumn,
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnTitle,
  DescriptionTextColumnContentRight,
  BlockContentValue
} from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import { SlideshowItem } from "components/Slideshow/Slideshow";
import React from "react";
import { arrayIsNotEmpty } from "src/utils/checks";
import { BlockContent } from "components/BlockContent";
const ResponsiveSlideshow = React.lazy(
  () => import("components/Slideshow/ResponsiveSlideshow")
);

type Props = {
  content?: BlockContentValue;
  images?: SlideshowItem[];
};

const OnboardEnrichments: React.FC<Props> = ({ images, content }) => {
  return (
    <DescriptionTextColumn>
      <DescriptionTextColumnContent>
        <DescriptionTextColumnContentLeft>
          <DescriptionTextColumnTitle>
            <Trans id="default-cruise-onboard-enrichments-title">
              Onboard Enrichments
            </Trans>
          </DescriptionTextColumnTitle>
          <BlockContent value={content} />
        </DescriptionTextColumnContentLeft>
        <DescriptionTextColumnContentRight>
          {arrayIsNotEmpty(images) && (
            <React.Suspense>
              <ResponsiveSlideshow
                items={images}
                variant="dark"
                dataContentName="slideshow"
              />
            </React.Suspense>
          )}
        </DescriptionTextColumnContentRight>
      </DescriptionTextColumnContent>
    </DescriptionTextColumn>
  );
};

export default OnboardEnrichments;
